import { useMemo } from "react";
import { useFormStore } from "@/widgets/classic-form/form";
import { GroupType, NameAssertion, ResponseItemType, useMetadataQuery } from "@/entities/form-metadata";

export const useNameExactness = () => {
    const { data: formMetadata } = useMetadataQuery();

    // Name fields are different from other types
    // While event, family or other instances in formData reflect metadata
    // name fields are always present and have exactness features
    const supportedFields = useMemo(() => {
        let givenNameSupported = false;
        let surnameSupported = false;
        for (const entry of formMetadata.fieldGroupsAndFeatureContainers) {
            if (entry.type === ResponseItemType.FieldGroup && entry.groupType === GroupType.Name) {
                for (const field of entry.fields) {
                    if (field.assertion === NameAssertion.GivenName) givenNameSupported = true;
                    if (field.assertion === NameAssertion.Surname) surnameSupported = true;
                }
                // Early return, no need to traverse the rest of the list
                if (givenNameSupported && surnameSupported) {
                    return { givenName: givenNameSupported, surname: surnameSupported };
                }
            }
        }
        return { givenName: givenNameSupported, surname: surnameSupported };
    }, [formMetadata.fieldGroupsAndFeatureContainers]);

    const isExact = useFormStore((store) => {
        const givenNameIsExact = supportedFields.givenName
            ? store.values.name.givenNameExactness.isExact
            : // Mark as true to ignore it
              true;
        const surnameIsExact = supportedFields.surname
            ? store.values.name.surnameExactness.isExact
            : // Mark as true to ignore it
              true;
        return givenNameIsExact && surnameIsExact;
    });

    return isExact;
};
